export default __webpack_public_path__ + "static/media/239.4c733310.png";